<template>
  <div>
    <SoWidget
      filled
      title="Meter Photo Requests"
      data-testid="photo-request-widget"
    >
      <SoAlert class="mt-3 mb-1" type="warning">
        New photo requests are currently disabled in Nova. Please contact the
        customer directly to request photos.
      </SoAlert>

      <template v-if="hasOutboundRequest">
        <div
          v-for="(outboundRequest, index) in outboundPhotoRequestData"
          :key="index"
          class="d-flex vertical align-center mb-1 mt-5"
        >
          <SoStatus
            ref="request-photo-status"
            on-surface
            :status="existingChipModalStatus(outboundRequest)"
          />
          <SoButton
            title="See Request Details"
            data-testid="existing-photo-request-btn"
            class="ml-3"
            @click="isExistingRequestModalOpen = true"
          />
          <ActivePhotoRequestModal
            v-model="isExistingRequestModalOpen"
            :outbound-request="outboundRequest"
            :existing-chip-modal-status="
              existingChipModalStatus(outboundRequest)
            "
            @on-refetch-outbound-photo="refetchOutboundPhotoRequest()"
          />
        </div>
      </template>
    </SoWidget>
    <PhotoRequestModal v-model="isNewRequestModalOpen" />
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoWidget from "@/components/SoWidget.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import SoStatus from "@/components/SoStatus.vue"
  import SoAlert from "@/components/SoAlert.vue"
  import PhotoRequestModal from "../modals/PhotoRequestModal.vue"
  import ActivePhotoRequestModal from "../modals/ActivePhotoRequestModal.vue"
  import { MeterReadingsService } from "@/services/operations/MeterReadingsService"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { externalRoutes } from "@/constants/routes/externalRoutes"
  import { Status } from "@/types/Status"

  export default defineComponent({
    components: {
      SoWidget,
      SoButton,
      SoStatus,
      SoAlert,
      PhotoRequestModal,
      ActivePhotoRequestModal,
    },
    data() {
      return {
        isNewRequestModalOpen: false,
        isExistingRequestModalOpen: false,
        isPhotoRequestBtnEnabled: false,
        outboundPhotoRequestQuery: MeterReadingsService.getOutboundPhotoRequest(
          useCurrentAccountStore().accountNumber,
        ),
        externalRoutes,
        Status,
      }
    },
    computed: {
      hasOutboundRequest() {
        return this.outboundPhotoRequestQuery.isFetching
          ? true // assume it has requst until we know
          : !!this.outboundPhotoRequestData.length
      },
      outboundPhotoRequestData() {
        return this.outboundPhotoRequestQuery &&
          !this.outboundPhotoRequestQuery.isFetching
          ? this.outboundPhotoRequestQuery.data
          : []
      },
      hasEmailAddress() {
        return useCurrentAccountStore().accountContacts.data.some(
          (contact) => contact.email,
        )
      },
    },
    watch: {
      isNewRequestModalOpen(value) {
        if (!value) {
          this.isPhotoRequestBtnEnabled = false
        }
      },
    },
    methods: {
      refetchOutboundPhotoRequest() {
        this.outboundPhotoRequestQuery.refetch()
        this.isExistingRequestModalOpen = false
      },
      existingChipModalStatus(outboundRequest) {
        switch (outboundRequest.status) {
          case "FIRST_FOLLOW_UP_SENT":
            return new Status(
              "caution",
              `First follow-up sent ${outboundRequest?.lastEmailSentAt}`,
            )
          case "SECOND_FOLLOW_UP_SENT":
            return new Status(
              "critical",
              `Second follow-up sent ${outboundRequest?.lastEmailSentAt}`,
            )
          default:
            return new Status(
              "caution",
              `Photo Requested ${outboundRequest?.createdAt}`,
            )
        }
      },
    },
  })
</script>
